import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class FormUserAccessLinkService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);


        this.FORM_USER_ACCESS_LINK = '/api/form-user-access-link';

        this.GET_LIST_BY_PROJECT = '/list/project/{projectId}';
        this.GET_LIST_BY_FORM = '/list/form/{formId}';
        this.GET_LIST_BY_EMAIL = '/list/email/{email}';
        this.GET_BY_EMAIL_AND_FORM = '/email/{email}/form/{formId}';
    }

    async getListByProject(projectId) {
        try {
            let url = window.location.origin + this.FORM_USER_ACCESS_LINK + this.GET_LIST_BY_PROJECT;
            url = url
                .replace('{projectId}', projectId);
            const invitations = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return invitations;
        } catch (err) {
            console.log(err);
        }
    }

    async getListByForm(formId) {
        try {
            let url = window.location.origin + this.FORM_USER_ACCESS_LINK + this.GET_LIST_BY_FORM;
            url = url
                .replace('{formId}', formId);
            const invitations = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return invitations;
        } catch (err) {
            console.log(err);
        }
    }

    async getListByEmail(email) {
        try {
            let url = window.location.origin + this.FORM_USER_ACCESS_LINK + this.GET_LIST_BY_EMAIL;
            url = url
                .replace('{email}', email);
            const invitations = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return invitations;
        } catch (err) {
            console.log(err);
        }
    }

    async getByEmailAndForm(email, formId) {
        try {
            let url = window.location.origin + this.FORM_USER_ACCESS_LINK + this.GET_BY_EMAIL_AND_FORM;
            url = url
                .replace('{email}', email)
                .replace('{formId}', formId);
            const invitations = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return invitations;
        } catch (err) {
            console.log(err);
        }
    }
}

export default FormUserAccessLinkService;
